var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDepartmentwiseStatistics(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 513373"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 513372"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.99609 16.4074L10.1524 13.8199C11.0068 12.7946 11.434 12.2818 11.9961 12.2818C12.5581 12.2818 12.9853 12.7946 13.8399 13.8199L14.1523 14.195C15.0069 15.2203 15.4341 15.733 15.9961 15.733C16.5581 15.733 16.9854 15.2203 17.8398 14.195L19.9961 11.6074",
    stroke: "#426CFF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M25.9961 14C25.9961 19.6568 25.9961 22.4853 24.2387 24.2426C22.4814 26 19.6529 26 13.9961 26C8.33923 26 5.51081 26 3.75346 24.2426C1.99609 22.4853 1.99609 19.6568 1.99609 14C1.99609 8.34314 1.99609 5.51472 3.75346 3.75736C5.51081 2 8.33923 2 13.9961 2C19.6529 2 22.4814 2 24.2387 3.75736C25.4073 4.92585 25.7988 6.56786 25.93 9.2",
    stroke: "#426CFF",
    strokeWidth: 2.2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1243",
    cx: 25.0675,
    cy: 25.0714,
    r: 6.07143,
    fill: "#404385"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.3597 25.2727H22.2688C22.1052 25.2727 21.9961 25.3818 21.9961 25.5455V27.7273C21.9961 27.8909 22.1052 28 22.2688 28H23.3597C23.5234 28 23.6325 27.8909 23.6325 27.7273V25.5455C23.6325 25.3818 23.5234 25.2727 23.3597 25.2727ZM27.7234 24.1818H26.6325C26.4688 24.1818 26.3597 24.2909 26.3597 24.4545V27.7273C26.3597 27.8909 26.4688 28 26.6325 28H27.7234C27.887 28 27.9961 27.8909 27.9961 27.7273V24.4545C27.9961 24.2909 27.887 24.1818 27.7234 24.1818ZM25.5415 22H24.4506C24.287 22 24.1779 22.1091 24.1779 22.2727V27.7273C24.1779 27.8909 24.287 28 24.4506 28H25.5415C25.7052 28 25.8143 27.8909 25.8143 27.7273V22.2727C25.8143 22.1091 25.7052 22 25.5415 22Z",
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartmentwiseStatistics);
export default __webpack_public_path__ + "static/media/departmentwise_statistics.049a036099c28d41b27961e943aada8a.svg";
export { ForwardRef as ReactComponent };